export default {"src":"//tokenlon.im/_next/static/media/mascot-eyes-down.9011a05a.gif","height":200,"width":200};